import React, { createContext, useContext, useState } from "react";
import BookingModal, { BookingInfo } from "../components/BookingModal";

interface BookingModalContextValue {
  open: (info: BookingInfo) => void;
}

const BookingModalContext = createContext<BookingModalContextValue | null>(null);

/** Provides a single site-wide booking modal instance, shared by the navbar and every page. */
export const BookingModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [info, setInfo] = useState<BookingInfo | null>(null);

  return (
    <BookingModalContext.Provider value={{ open: setInfo }}>
      {children}
      {info !== null && <BookingModal info={info} onClose={() => setInfo(null)} />}
    </BookingModalContext.Provider>
  );
};

export function useBookingModal(): BookingModalContextValue {
  const ctx = useContext(BookingModalContext);
  if (!ctx) throw new Error("useBookingModal must be used within a BookingModalProvider");
  return ctx;
}
